import { SEARCH_OPTION_AGENTS, SEARCH_OPTION_HOME_APPRAISAL, SEARCH_OPTION_IN_SERVICE, SEARCH_OPTION_MILITARY_BASE, SEARCH_OPTION_COMMERCIAL } from '@tenants/types/theme';
import { DefaultSearchStrategy } from './DefaultSearchStrategy';
import { AgentSearchStrategy } from './AgentSearchStrategy';
import { HomeAppraisalSearchStrategy } from './HomeAppraisalSearchStrategy';
import { InServiceSearchStrategy } from './InServiceSearchStrategy';
import { MilitaryBaseSearchStrategy } from './MilitaryBaseSearchStrategy';
import { CommercialSearchStrategy } from './CommercialSearchStrategy';
import { SearchStrategy } from './SearchStrategy';
import type { SearchOptions } from '@tenants/types/theme';

export class SearchStrategyFactory {
  static getStrategy(searchOptions?: SearchOptions): SearchStrategy {
    if (searchOptions === SEARCH_OPTION_AGENTS) {
      return new AgentSearchStrategy();
    } else if (searchOptions === SEARCH_OPTION_HOME_APPRAISAL) {
      return new HomeAppraisalSearchStrategy();
    } else if (searchOptions === SEARCH_OPTION_IN_SERVICE) {
      return new InServiceSearchStrategy();
    } else if (searchOptions === SEARCH_OPTION_MILITARY_BASE) {
      return new MilitaryBaseSearchStrategy();
    } else if (searchOptions === SEARCH_OPTION_COMMERCIAL) {
      return new CommercialSearchStrategy();
    } else {
      return new DefaultSearchStrategy();
    }
  }
}